<ng-container
  [appTransition]="child"
  [show]="active()"
  [duration]="modalTransitionDuration"
  enter="transition-all"
  enterFrom="opacity-0"
  enterTo="opacity-100"
  leave="transition-all"
  leaveFrom="opacity-100"
  leaveTo="opacity-0"
  (afterLeave)="close()"
>
  <div #child class="modal-wrapper">
    <div
      [id]="modal().id"
      class="modal"
      [class.wide]="sections.length"
      *ngIf="modal()"
    >
      <div class="content">
        <div class="icon" [ngClass]="modal().type">
          <ng-container [ngSwitch]="modal().type">
            <span
              *ngSwitchCase="'error'"
              class="pi pi-exclamation-triangle"
            ></span>
            <span *ngSwitchCase="'confirm'" class="pi pi-question"></span>
            <span *ngSwitchCase="'success'" class="pi pi-check"></span>
            <span *ngSwitchCase="'info'" class="pi pi-info"></span>
            <span *ngSwitchCase="'input'" class="pi pi-pencil"></span>
            <span
              *ngSwitchCase="'deletion'"
              class="pi pi-exclamation-triangle"
            ></span>
          </ng-container>
        </div>
        <div class="message">
          <p>{{ modal().title }}</p>
          <ng-container *ngFor="let message of $any(messages)">
            <span>{{ message }}</span>
          </ng-container>
        </div>
      </div>
      <!-- Resumo para conferência (ex.: dados da NFS-e antes de emitir). -->
      <div *ngIf="sections.length" class="summary">
        <section *ngFor="let section of sections" class="summary-section">
          <h3>{{ section.title }}</h3>
          <dl>
            <div
              *ngFor="let row of section.rows"
              class="summary-row"
              [class.highlight]="row.highlight"
              [class.block]="row.block"
            >
              <dt>{{ row.label }}</dt>
              <dd>{{ row.value }}</dd>
            </div>
          </dl>
        </section>
      </div>
      <div *ngIf="inputs.length" class="input">
        <app-fields [formGroup]="form()">
          <ng-container *ngFor="let field of inputs">
            <app-input
              *ngIf="field.type !== 'select'; else selectField"
              [label]="field.label"
              [type]="field.type ?? 'text'"
              [formControlName]="field.fieldName"
              [hint]="field.hint ?? ''"
              [invalidMessage]="field.invalidMessage ?? ''"
              [isValid]="field.isValid"
            ></app-input>

            <ng-template #selectField>
              <app-select
                [label]="field.label"
                [formControlName]="field.fieldName"
                [options]="field.options ?? []"
              ></app-select>
            </ng-template>
          </ng-container>
        </app-fields>
      </div>
      <!--
        Com três opções os botões não cabem lado a lado nos 400px do modal e
        quebravam a linha de qualquer jeito: empilha em coluna, do mais
        importante (confirmar, no topo) para a saída segura (no rodapé).
      -->
      <div class="footer" [class.stacked]="hasNeutral">
        <app-button
          *ngIf="hasNeutral"
          (click)="neutral()"
          (keydown.enter)="neutral()"
          backgroundColor="var(--slate-350)"
          [fullWidth]="hasNeutral"
          [dense]="hasNeutral"
          [text]="modal().neutralText ?? ''"
        ></app-button>
        <app-button
          *ngIf="
            modal().type === 'confirm' ||
            modal().type === 'deletion' ||
            modal().type === 'input'
          "
          (click)="cancel()"
          (keydown.enter)="cancel()"
          [backgroundColor]="modal().cancelColor ?? 'var(--slate-350)'"
          [fullWidth]="hasNeutral"
          [dense]="hasNeutral"
          [text]="modal().cancelText ?? 'Cancelar'"
        ></app-button>
        <app-button
          [fullWidth]="hasNeutral"
          [dense]="hasNeutral"
          (click)="confirm()"
          (keydown.enter)="confirm()"
          [disabled]="!isValid"
          [text]="modal().confirmText ?? 'Ok'"
        ></app-button>
      </div>
    </div>
  </div>
</ng-container>
